export default "__VITE_ASSET__CPNqzgWP__"